// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"309":"1bd7662983a48c9f","402":"fae4faa5d824138b","727":"eabb0f3345872edf","765":"11c00cc89eaf44f1"}[chunkId] + ".js";
};